/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Auswahl löschen',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Daten konnten nicht abgerufen werden.',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klicken, um es erneut zu versuchen',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Lädt ...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mehr anzeigen',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} von {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Keine Treffer gefunden',
  'paginated-picker.async-select.select.option.error-message': 'Daten konnten nicht abgerufen werden.',
  'paginated-picker.async-select.select.option.retry-message': 'Klicken, um es erneut zu versuchen',
  'paginated-picker.async-select.select.search-placeholder': 'Suchen',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vollständige Liste anzeigen'
};